// src/authConfig.js

const tenantName = "CertStudents"; // e.g., "contoso" if your domain is contoso.onmicrosoft.com
const userFlow = "B2C_1_sus1";          // The user flow or policy you created
const clientId = "052b120c-6b10-4f7e-9c31-c66b6da80316";    // From app registration

export const msalConfig = {
  auth: {
    clientId,
    authority: `https://${tenantName}.b2clogin.com/${tenantName}.onmicrosoft.com/${userFlow}`,
    knownAuthorities: [`${tenantName}.b2clogin.com`],
    redirectUri: process.env.REACT_APP_REDIRECT_URI || "http://localhost:3000",
    postLogoutRedirectUri: process.env.REACT_APP_REDIRECT_URI || "http://localhost:3000",
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["openid", "profile"],
  // If you need access to an API, you could add e.g. `"api://<YOUR_API_CLIENT_ID>/access_as_user"`.
};

